import React, { useContext } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Context as ConfigContext } from '../Config';
import usePageClassName from '../hooks/usePageClassName';
import useHomePageData from '../hooks/useHomePageData';
import useTranslation from '../hooks/useTranslation';
import HomeSchema from '../toolkit/HomeSchema';
import WithTitle from '../toolkit/WithTitle';
import { HomeContext } from '../contexts';
import ErrorPage from './error';
import Error401Page from './error401';

type Props = RouteComponentProps;

const HomePage: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  usePageClassName('index-page');
  const { fetchingStatus, data } = useHomePageData();
  const { pages, pageLoadingIndicator: Loader } = useContext(ConfigContext);

  if (
    fetchingStatus === 'is-fetching' ||
    fetchingStatus === 'not-started'
    // || fetchingStatus === 'NotAllowedError'
  )
    return <Loader />;
  if (fetchingStatus === 'LoginRequired') return <Error401Page />;
  if (fetchingStatus !== 'has-fetched' || !data) return <ErrorPage />;

  const title = t('pageTitles.home');
  const Page = pages.home.component;

  return (
    <HomeContext.Provider value={data}>
      <>
        <HomeSchema />
        <WithTitle title={title}>
          <Page />
        </WithTitle>
      </>
    </HomeContext.Provider>
  );
};

HomePage.displayName = 'HomePage';

export default HomePage;
